
export var PAGE_TITLE_LABEL_KEY = 'SEARCH';
export var RESULTS_PAGE_SIZE = 20;
